

















































import mixins from 'vue-typed-mixins';
import { Page } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Page,
    },
  },
});
